var $b1bf14102833c31a$exports = {};
$b1bf14102833c31a$exports = {
  "collapse": "Sbalit",
  "expand": "Rozt\xE1hnout"
};
export { $b1bf14102833c31a$exports as default };